<div class="d-flex">
  <fa-icon [icon]="icon" class="mr-3 showcase-icon"></fa-icon>
  <div class="d-inline-flex flex-column justify-content-center">
    <h3 class="showcase-title" data-automation-id="showcase-title">
      <ng-content></ng-content>
    </h3>
    <app-showcase-created-by [creator]="creator"></app-showcase-created-by>
  </div>
</div>
